import type { TFunction } from 'i18next';

import type { AnswerAndQuestion } from '@/components/AboutUsContainer/AnswerQuestionSection/AnswerQuestionSection.utils';

export const calcAnswerAndQuestions = (t: TFunction): AnswerAndQuestion[] =>
	Array.from({ length: 16 }, (_, index) => ({
		question: t(`faq.${index + 1}.question`),
		answer: t(`faq.${index + 1}.answer`),
	}));
